<template>
  <div class="fullpage-container">
    <div class="fullpage-wp" v-fullpage="opts" ref="fullPage">
      <div
        class="page-1 page rel bg-bottom bg-cover"
        style="background-image: url(https://static.wkanx.com/w002/M00/05/F4/CgIXGF6dg1SAfjLZAAAmsENNDwE546.jpg)"
      >
        <Topbar />
        <div class="page-main fs20 color-white tc">
          <div class="fs28" v-animate="{ value: 'zoomIn' }">联系我们</div>
          <img
            src="https://static.wkanx.com/w002/M00/05/F4/CgIXlV6dgkKAQ0cwAABnyKSfONE587.png"
            style="width: 2.43rem; margin: 0.2rem 0 0"
          />
        </div>
        <div class="page-footer">
          <Contact type="info" />
          <NextPage class="m-t-2" type="1" @next="moveNext" />
        </div>
      </div>
      <div class="page-2 page color-primary">
        <Header />
        <div class="page-main tc full-width rfs12">
          <div style="margin: 0 0 0.25rem">官方微信</div>
          <div class="rfs12 color-default">（用户名：WiFiMasterKey）</div>
          <img
            class="db bc"
            src="https://static.wkanx.com/w002/M00/05/B4/CgIXgV6EPcGAZZkAAAA-okCopgw850.jpg"
            style="width: 0.75rem"
          />
          <div class="m-t-6" style="margin: 0 0 0.25rem">广告咨询合作</div>
          <div class="color-default">广告合作客服邮箱：<a href="mailto:yt@zenmen.com">yt@zenmen.com</a></div>
          <!-- <div class="color-default">广告合作客服QQ：3007314925</div> -->
          <div class="m-t-6" style="margin: 0 0 0.25rem">客服电话</div>
          <div class="color-default">广告合作客服电话：<a href="tel:13818759977">13818759977</a></div>
        </div>
        <div class="page-footer">
          <Contact />
          <NextPage class="m-t-2" @next="moveNext" />
        </div>
      </div>
      <div class="page-3 page color-primary" style="background: #52b1ff">
        <Header type="2" menuType="light" />
        <div class="page-main tc color-white">
          <div class="rfs12 tc" style="padding: 0 0.45rem 0.25rem">公司地址</div>
          <img
            class="db bc m-b-1"
            src="https://static.wkanx.com/w002/M00/05/B4/CgIXGF6EPtmAOAXeAAGFz0vTXI8629.jpg"
            style="width: 3.2rem"
          />
          <div class="rfs12 m-b-4">
            上海：上海市浦东新区张衡路666弄1号7楼，总机电话
            <a href="tel:021-68639700" class="color-white">021-68639700</a>
          </div>
          <img
            class="db bc m-b-1"
            src="https://static.wkanx.com/w002/M00/05/B4/CgIXgV6EPweADzOfAAINLx4M5BI086.jpg"
            style="width: 3.2rem"
          />
          <div class="rfs12">北京：北京市海淀区创业路6号自主创新大厦4楼</div>
        </div>
        <div class="page-footer">
          <Contact type="info" />
          <NextPage class="m-t-2" type="1" @next="moveNext" />
        </div>
      </div>
      <div class="page-4 page color-primary" style="background: #52b1ff">
        <Header type="2" menuType="light" />
        <div class="page-main tc color-white">
          <div class="rfs12 tc" style="padding: 0 0.45rem 0.25rem">公司地址</div>
          <img
            class="db bc m-b-1"
            src="https://static.wkanx.com/w002/M00/05/B4/CgIXGF6EPwCAMf68AAGA6XY-nwY136.jpg"
            style="width: 3.2rem"
          />
          <div class="rfs12 m-b-4">南京：江苏省南京市建邺区白龙江东街8号A3栋16层南</div>
          <img
            class="db bc m-b-1"
            src="https://static.wkanx.com/w002/M00/05/B4/CgIXlV6EPxOAdEmVAAFA3BIlFYM271.jpg"
            style="width: 3.2rem"
          />
          <div class="rfs12">广州（分公司）：广州市天河区林和东路285号天安人寿1703-1704单元</div>
        </div>
        <Contact type="info" class="page-footer m-b-6" />
      </div>
    </div>
  </div>
</template>
<script>
import Base from './Base';

export default {
  name: '',
  props: {},
  extends: Base,
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang='scss' scoped>
.page-3,
.page-4 {
  img {
    border-radius: 8px;
  }
}
</style>
